<template>
  <div class="app">
	<!-- <heads :title="title" type="2"></heads> -->
	<div class="content">
		<van-empty v-if="list.length == 0" description="暂无数据" />
		<div v-else class="content-nav" v-for="item in list" @click="goPage(item)">
			<div class="content-nav-card">
				<div>
					<img :src="item.jqtps[0]" alt="">
				</div>
				<div>
					<div>
						<h3>{{item.jqmc}}</h3>
					</div>
					<p>联系电话：{{item.jqdh}}</p>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import{httpAction,getAction,putAction} from "@/api/manage"
import { Toast,Picker } from 'vant'
export default {
	props: {
		list: {
		type: Array,
            default() {
                return []
            },
		},
		pth: {
            type: String,
            default: "/hmhq/lyjqView",
		},
	},
	data(){
		return{
		}
	},
	mounted() {

	},
	methods:{
		goPage(e){
			this.$store.state.wallView = e
			let params = {id:e.id}
			this.$router.push({
				path:this.pth,
				query:params
			})
		}
	}
}
</script>

<style scoped lang="less">
.app{
	width: 100%;
	height: 100vh;
	background-color: #f6f7f9;
}
p{
	margin: 0px;
	padding: 0px;
}
input{
	border: none
}
.content{
	padding: 20px 10px;
	font-size: 16px;
	box-sizing: border-box;
	&-nav{
		width: 100%;
		border-radius: 4px;
		background: white;
		margin-bottom: 16px;
		&-card{
			padding: 10px 20px;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
			>div:first-child{
				width: 24%;
				height: 80px;
				border: 1px solid #f5f5f5;
				img{
					width: 100%;
					height: 100%;
				}
			}
			>div:last-child{
				width: 64%;
				>div{
					display: flex;
				}
				h3{
					font-size: 18px;
					margin: 0px 12px 0px 0px;
				}
				p{
					font-size: 12px;
					margin: 10px 0px;
				}
				span{
					border-radius: 4px;
					text-align: center;
					display: block;
					line-height: 16px;
					padding: 2px 6px;
					border: 1px solid #0099ff;
					background-color: #e6f5ff;
					color: #0099ff;
					font-size: 12px;
				}
			}
		}
	}
}
</style>